import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FOCUS } from '../../components/ui/tokens';

/**
 * A figure that opens the bills behind it. A real `<a href>` (so it can be opened in a new tab,
 * copied, or read by a screen reader as a link), with an ordinary click handled in the app
 * instead of reloading the page.
 */
export const ReportLink: React.FC<{
  href: string;
  /** What the link says to a screen reader: the figure, plus whose and which column it is. */
  label: string;
  children: React.ReactNode;
  className?: string;
}> = ({ href, label, children, className = '' }) => {
  const navigate = useNavigate();
  return (
    <a
      href={href}
      aria-label={label}
      onClick={(event) => {
        // Let the browser have a new-tab / new-window click; handle the plain one here.
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }
        event.preventDefault();
        navigate(href);
      }}
      className={`rounded-sm text-primary-600 underline-offset-2 hover:underline ${FOCUS} ${className}`}
    >
      {children}
    </a>
  );
};

export default ReportLink;
